<template>
<div class="dict-mange">
    <el-card class="filter-card">
        <div slot="header" class="clearfix">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>字典管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-form :inline="true" :model="params" class="demo-form-inline" label-width="110px">
            <el-form-item label="字典名称">
                <el-input v-model="params.dictName" placeholder="请输入字典名称" size="small"></el-input>
            </el-form-item>
            <el-form-item label="字典类型">
                <el-input v-model="params.dictType" placeholder="请输入字典类型" size="small"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button icon="el-icon-search" type="primary" @click="onSubmit" size="small">查 询</el-button>
                <el-button icon="el-icon-plus" type="primary" @click="changeRoleInfo" size="small">新 增</el-button>
            </el-form-item>
        </el-form>
    </el-card>
    <el-card style="margin-top: 10px;">
        <el-table
            :data="dictList"
            :header-cell-style="{background: '#eef1f6', color: '#606266', fontWeight: 'bolder'}"
            stripe
            v-loading="loading"
            style="width: 100%">
            <el-table-column
                type="index"
                label="序号"
                width="55"
                align="center"
            >
            </el-table-column>
            <el-table-column
                prop="dictName"
                label="字典名称"
                align="center">
            </el-table-column>
            <el-table-column
                prop="dictType"
                label="字典类型"
                align="center">
            </el-table-column>
            <el-table-column
                prop="dictCode"
                label="字典编码"
                align="center">
            </el-table-column>
            <el-table-column
                prop="dictValue"
                label="字典值"
                align="center">
            </el-table-column>
            <el-table-column
                prop="dictDesc"
                label="字典描述"
                align="center">
            </el-table-column>
            <el-table-column
                label="创建人"
            >
                <template slot-scope="scope">
                    {{ scope.createdTime | moment }}
                </template>
            </el-table-column>
            <el-table-column
                label="操作"
                width="200"
            >
                <template slot-scope="scope">
                    <el-button size="mini" icon="el-icon-edit" type="info" @click="changeRoleInfo(scope.row)">编 辑</el-button>
                    <el-button size="mini" icon="el-icon-delete" type="danger" @click="deleteDictItem(scope.row.dictId)">删 除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            class="pagination"
            background
            @size-change="handleSizeChange"
            @current-change="changePage"
            :current-page="params.pageNo"
            :page-sizes="[10, 20, 50, 100, 200]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount">
        </el-pagination>
    </el-card>
    <!-- 新增/删除字典信息 -->
    <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="30%"
        append-to-body
        top="5vh"
        :before-close="handleClose"
    >
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="字典名称" prop="dictName">
                <el-input v-model="ruleForm.dictName" placeholder="请输入字典名称"></el-input>
            </el-form-item>
            <el-form-item label="字典类型">
                <el-input v-model="ruleForm.dictType" placeholder="请输入字典类型"></el-input>
            </el-form-item>
            <el-form-item label="字典编码">
                <el-input v-model="ruleForm.dictCode" placeholder="请输入字典编码"></el-input>
            </el-form-item>
            <el-form-item label="字典值">
                <el-input v-model="ruleForm.dictValue" placeholder="请输入字典值"></el-input>
            </el-form-item>
            <el-form-item label="类型">
                <el-radio-group v-model="ruleForm.typeId">
                    <el-radio :label="0">系统</el-radio>
                    <el-radio :label="1">用户自定义</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="changeDictItem('ruleForm')">确 定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import { getPageList, deleteDictInfo, changeDictInfo } from '@/api/dictMange';
import { hasBtnPermission } from "@/utils";
export default {
    name: "dictMange",
    data(){
        return{
            loading: false,
            dialogVisible: false,
            // 字典列表
            dictList: [],
            params: {
                dictName: '',
                dictType: '',
                pageNo: 1,
                pageSize: 10
            },
            totalCount: null,
            title: '新增',
            ruleForm: {
                dictName: '', // 字典名称
                dictType: '', // 字典类型
                dictCode: '', // 字典编码
                dictValue: '', // 字典值
                typeId: '0', // 类型
                createdBy: '', // 创建人
            },
            rules: {
                dictName: [
                    { required: true, message: '请输入字典名称', trigger: 'blur' }
                ]
            }
        }
    },
    created() {
        this.getPageData()
    },
    methods: {
        // 获取字典列表
        async getPageData(){
            this.loading = true;
            const res = await getPageList(this.params);
            if(res.code === '200'){
                this.dictList = res.data.list
                this.totalCount = res.data.total
            }else{
                this.$message.error(res.msg)
            }
            this.loading = false;
        },
        // 点击查询
        onSubmit(){
            this.getPageData()
        },
        // 新增/查询字典
        changeRoleInfo(item){
            for(let key in this.ruleForm){
                if(this.ruleForm[key] !== 'typeId'){
                    this.ruleForm[key] = ''
                }
            }
            item.dictName ? this.title = '编辑' : this.title = '新增'
            if(item.dictName){
                if(!hasBtnPermission('sys:dict:update')){
                    this.$message.warning('您暂无权限操作')
                    return
                }
                this.title = '编辑'
                this.ruleForm = JSON.parse(JSON.stringify(item))
            }else{
                if(!hasBtnPermission('sys:dict:save')){
                    this.$message.warning('您暂无权限操作')
                    return
                }
                this.title = '新增'
            }
            this.dialogVisible = true
        },
        changeDictItem(formName){

            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.confirmChangeDictInfo()
                } else {
                    return false;
                }
            });
        },
        async confirmChangeDictInfo(){
            this.ruleForm.createdBy = JSON.parse(window.sessionStorage.getItem('userInfo')).userId
            const res = await changeDictInfo(this.ruleForm);
            if(res.code === '200'){
                this.title === '新增' ? this.$message.success('添加成功') : this.$message.success('修改成功')
                this.getPageData()
                this.dialogVisible = false
            }else{
                this.$message.error(res.msg)
            }
        },
        // 删除字典
        async deleteDictItem(id){
            if(!hasBtnPermission('sys:dict:delete')){
                this.$message.warning('您暂无权限操作')
                return
            }
            this.$confirm('确定删除该数据吗？','提示')
                .then(_ => {
                    this.confirmDeleteDictItem(id)
                })
                .catch(_ => {})
        },
        async confirmDeleteDictItem(id){
            const res = await deleteDictInfo(id);
            if(res.code === '200'){
                this.$message.success('删除成功')
                this.getPageData()
            }else{
                this.$message.error(res.msg)
            }
        },
        // 页码改变
        changePage(e){
            this.params.pageNo = e;
            this.getPageData()
        },
        handleSizeChange(e){
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getPageData()
        },
        handleClose(){
            this.dialogVisible = true
        }
    }
}
</script>

<style scoped>
::v-deep .el-date-editor--datetimerange {
    width: 380px;
}

::v-deep .el-form--inline {
    height: 40px;
}
::v-deep .el-table{
    margin-bottom: 20px;
}
</style>
<style scoped lang="scss">
.search-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 30px;
}
.pagination{
    margin: 20px 0 0;
}
</style>
